import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import HomepageBlocksList from './components/HomepageBlocksList';
import HomepageBlockForm from './components/HomepageBlockForm';
import SingleHomepageBlock from './single';

const HomepageBlocksRoutes = () => {
  return (
    <Routes>
      <Route path='' element={<HomepageBlocksList />} />
      <Route path='create' element={<HomepageBlockForm />} />
      <Route path='edit/:id' element={<HomepageBlockForm />} />
      <Route path=':id' element={<SingleHomepageBlock />} />
      <Route path='*' element={<Navigate to='' replace />} />
    </Routes>
  );
};

export default HomepageBlocksRoutes;
